import { format } from 'https://cdn.jsdelivr.net/npm/date-fns/+esm';

export const COMPACT_DATE_DATE = 'MMM dd, yyyy';
export const COMPACT_DATE_TIME = 'hh:mm:ss aaa';
export const COMPACT_DATE = `${COMPACT_DATE_DATE} ${COMPACT_DATE_TIME}`;

export function formatToCompactDate(datetime) {

  return format(datetime, COMPACT_DATE);

}

export function toFuzzyTime(currentTime, date) {

  var delta = Math.round((+currentTime - date) / 1000);

  var minute = 60,
    hour = minute * 60,
    day = hour * 24,
    week = day * 7;

  var fuzzy;

  if (delta < 30) {
    fuzzy = 'just now';
  } else if (delta < minute) {
    fuzzy = delta + ' secs ago';
  } else if (delta < 2 * minute) {
    fuzzy = 'a min ago';
  } else if (delta < hour) {
    fuzzy = Math.floor(delta / minute) + ' mins ago';
  } else if (Math.floor(delta / hour) === 1) {
    fuzzy = '1 hr ago';
  } else if (delta < day) {
    fuzzy = Math.floor(delta / hour) + ' hrs ago';
  } else if (delta < day * 2) {
    fuzzy = 'yesterday';
  } else if (delta < week) {
    fuzzy = Math.floor(delta / day) + ' days ago';
  } else if (Math.floor(delta / week) === 1) {
    fuzzy = '1 week ago';
  } else {
    fuzzy = Math.floor(delta / week) + ' weeks ago';
  }

  return fuzzy;

}